import React, { useState, useEffect } from "react";
import licenseHorizontal from "~/images/license/horizontal.png";
import licenseVertical from "~/images/license/vertical.png";

const LicenseImage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const checkMobile = () => {
        setIsMobile(window.innerWidth < 1024);
      };

      checkMobile(); // check ตอน mount
      window.addEventListener("resize", checkMobile);

      return () => {
        window.removeEventListener("resize", checkMobile);
      };
    }
  }, []);

  return (
    <div className="flex justify-center items-center">
      <a
      href="https://access.gaminglabs.com/Certificate/Index?i=537"
      target="_blank"
      rel="noopener noreferrer"
      >
        <img
          src={isMobile ? licenseVertical : licenseHorizontal}
          alt="License"
          className="w-full h-auto"
          style={isMobile ? { marginBottom: '76px' } : {}}
        />
      </a>
    </div>
  );
};

export default LicenseImage;
